import { render, staticRenderFns } from "./AdvertisingChart.vue?vue&type=template&id=c8220b02"
import script from "./AdvertisingChart.vue?vue&type=script&lang=js"
export * from "./AdvertisingChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports